import { modalOverrides, sponsorModal, textModal } from "./common"

export default [
    {
        width: "4.8%",
        height: "10%",
        left: "30.2%",
        top: "24.4%",
        label: "Crowdstrike - Contact us",
        isExternal: true,
        onClick: () => {
            document.getElementById("Crowdstrike").click()
        }
    },
    {
        width: "5.8%",
        height: "7%",
        left: "35.5%",
        top: "15.4%",
        label: "Crowdstrike - Play Content",
        isExternal: true,
        modalOverrides,
        modal: <div style={{height: "100%", width: "100%"}}>
            <iframe width="100%" height="100%" frameBorder="0"  src="https://player.vimeo.com/video/764614063?h=295e0d01b4&autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen autoplay/>
        </div>
    },
    {
        width: "4.6%",
        height: "11%",
        left: "41.4%",
        top: "23.4%",
        label: "Crowdstrike - Global Threat report",
        isExternal: true,
        href: "https://assets.swoogo.com/uploads/2162248-635c181722645.pdf",
        target: "_blank"
    },
    {
        width: "6%",
        height: "7%",
        left: "35.4%",
        top: "8.4%",
        label: "Crowdstrike - Social Media",
        isExternal: true,
        modalOverrides: textModal(),
        modal: sponsorModal("Booth 3", "Crowdstrike", 
        <>
            CrowdStrike Holdings, Inc. (Nasdaq: CRWD), a global cybersecurity leader, has redefined modern security with 
            one of the world’s most advanced cloud-native platforms for protecting critical areas of enterprise risk – endpoints 
            and cloud workloads, identity and data. Powered by the CrowdStrike Security Cloud and world-class AI, the 
            CrowdStrike Falcon® platform leverages real-time indicators of attack, threat intelligence, evolving adversary 
            tradecraft and enriched telemetry from across the enterprise to deliver hyper-accurate detections, automated 
            protection and remediation, elite threat hunting and prioritised observability of vulnerabilities. Purpose-built in the 
            cloud with a single lightweight-agent architecture, the Falcon platform delivers rapid and scalable deployment, 
            superior protection and performance, reduced complexity and immediate time-to-value.
            <p><b>CrowdStrike: We stop breaches.</b></p>
        </>, {
            twitter: "https://twitter.com/CrowdStrike?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor",
            facebook: "https://en-gb.facebook.com/CrowdStrike/",
            instagram: "https://www.instagram.com/crowdstrike/",
            company: "https://www.crowdstrike.com/"
        })
    }
]
